<div id="four-step-container" *ngIf="useSloa" data-testid="four-step-container-selection" class="table">
    <span id="four-step-address-header" class="ft-16">{{thirdIntermediaryHeader}}</span>
    <div class="medium-bottom-spacer">
        <div id="resp-table">
        <div id="resp-table-body">
            <div class="resp-table-row">
            <span class="table-body-cell schwab-grey" *ngIf="thirdIntermediaryAccountNumber">
                {{thirdIntermediaryUseSloaAccountNumberHeader}}
            </span>
            <span class="table-body-cell schwab-grey" *ngIf="thirdIntermediaryBIC">
                Business ID code (BIC)
            </span>
            <span class="table-body-cell schwab-grey" *ngIf="thirdIntermediaryClearingSysId">
                Clearing system ID
            </span>
            <span class="table-body-cell schwab-grey">
                Bank information
            </span>
            </div>
            <div class="resp-table-row">
            <span class="table-body-cell" *ngIf="thirdIntermediaryAccountNumber">
                {{thirdIntermediaryAccountNumber}}
            </span>
            <span class="table-body-cell" *ngIf="thirdIntermediaryBIC">
                {{thirdIntermediaryBIC}}
            </span>
            <span class="table-body-cell" *ngIf="thirdIntermediaryClearingSysId">
                {{thirdIntermediaryClearingSysId}}
            </span>
            <span class="table-body-cell" style="white-space: pre-line;">
                {{thirdIntermediaryUseSloaAddress}}
            </span>
            </div>
        </div>
        </div>
    </div>
</div>
